import React from 'react'
import content from '../../../../docs/legal/terms-of-service.md?raw'
import { MarkdownDoc } from '../../components/MarkdownDoc'

export default function Terms() {
  return (
    <div className="legal-page">
      <MarkdownDoc content={content} />
    </div>
  )
}
